export function mapNumToRole(n:number) {
  if(n===1) return "MEMBER"
  if(n===2) return "LEADER"
  if(n===3) return "OFFICER"
  return undefined
}